import { IInventoryScanOption } from '../../../types';
import { createZustandStore } from '../../../zustand';

import { IRemovePackageStore } from './types';

export const DEFAULT_SCAN_TYPE: IInventoryScanOption = {
  key: 'BAR_CODE',
  value: {
    ar: 'باركود',
    en: 'Bar Code',
  },
};

/**
 * This creates a local global state for Remove Package and update the
 * filters
 */
export const useRemovePackageStore = createZustandStore<IRemovePackageStore>()(
  (set) => ({
    blackBoxRemarks: '',
    updateBlackBoxRemarks: (text: string) =>
      set(() => ({ blackBoxRemarks: text })),
    packageDetails: null,
    updatePackageDetails: (packageDetails) => set(() => ({ packageDetails })),
    transferPodInfo: null,
    updateTransferPodInfo: (transferPodInfo) =>
      set(() => ({ transferPodInfo })),
    transferTrayInfo: null,
    updateTransferTrayInfo: (transferTrayInfo) =>
      set(() => ({ transferTrayInfo })),
    isPackageRemoved: false,
    currentScanStep: 'scanPackage',
    updateCurrentScanStep: (currentScanStep) =>
      set(() => ({ currentScanStep })),
    scanType: DEFAULT_SCAN_TYPE,
    updateScanType: (scanType) => set(() => ({ scanType })),
    suggestedTrayInfo: null,
    updateSuggestedTrayInfo: (suggestedTrayInfo) =>
      set(() => ({ suggestedTrayInfo })),
    isScannerReadingData: false,
    updateIsScannerReadingData: (isScannerReadingData) =>
      set(() => ({ isScannerReadingData })),
    packageIdentifier: '',
    updatePackageIdentifier: (packageIdentifier) =>
      set(() => ({ packageIdentifier })),
    resetStore: () =>
      set(() => ({
        packageDetails: null,
        transferPodInfo: null,
        transferTrayInfo: null,
        isPackageRemoved: false,
        currentScanStep: 'scanPackage',
        scanType: DEFAULT_SCAN_TYPE,
        isScannerReadingData: false,
        packageIdentifier: '',
      })),
  })
);
